import { gql } from '@apollo/client'

export const DELETE_MANY_FABRIC_FEATURES = gql`
  mutation DELETE_FABRIC_FEATURES($ids: [Int!]!) {
    deleteManyFabricFeature(where: { id: { in: $ids } }) {
      count
    }
  }
`

export const GET_FABRIC_FEATURES = gql`
  query GET_FABRIC_FEATURES(
    $searchTerm: String
    $take: Int
    $skip: Int
    $orderBy: [FabricFeatureOrderByWithRelationInput!]
  ) {
    findManyFabricFeature(
      where: {
        fabric_feature_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
      take: $take
      skip: $skip
      orderBy: $orderBy
    ) {
      id
      code
      photo {
        id
        src_xs
        src
      }
      fabric_feature_profiles {
        id
        name
        description
        language
      }
      _count {
        fabric_groups
      }
      createdAt
      updatedAt
    }
    findManyFabricFeatureCount(
      where: {
        fabric_feature_profiles: {
          some: { name: { contains: $searchTerm, mode: insensitive } }
        }
      }
    )
  }
`

export const GET_FABRIC_FEATURE = gql`
  query GetFabricFeature($id: Int!) {
    findUniqueFabricFeature(where: { id: $id }) {
      id
      code
      fabricFeatureGroupId
      photo {
        id
        src_xs
        src
      }
      fabric_feature_profiles {
        id
        name
        description
        language
      }
      _count {
        fabric_groups
      }
    }
  }
`

export const CREATE_FABRIC_FEATURE = gql`
  mutation CreateFabricFeature($data: CreateFabricFeatureWithProfilesInput!) {
    createFabricFeature(data: $data) {
      id
      code
      fabric_feature_profiles {
        name
        description
        language
      }
      photo {
        src
        src_xs
        name
      }
    }
  }
`

export const UPDATE_FABRIC_FEATURE = gql`
  mutation UpdateFabricFeature(
    $where: FabricFeatureWhereUniqueInput!
    $data: UpdateFabricFeatureWithProfilesInput!
  ) {
    updateFabricFeature(where: $where, data: $data) {
      id
      code
      photo {
        id
        src
        name
      }
      fabric_feature_profiles {
        id
        language
        name
        description
      }
    }
  }
`

export const DELETE_FABRIC_FEATURE = gql`
  mutation DeleteFabricFeature($where: FabricFeatureWhereUniqueInput!) {
    deleteOneFabricFeature(where: $where) {
      id
    }
  }
`

export const GET_FABRIC_FEATURES_TREE = gql`
  query GET_FABRIC_FEATURES_TREE {
    findManyFabricFeatureGroup(orderBy: { id: asc }) {
      id
      code
      fabric_feature_group_profiles {
        id
        name
        language
      }
      fabric_features(orderBy: { id: asc }) {
        id
        code
        photo {
          id
          src_xs
          src
        }
        fabric_feature_profiles {
          id
          name
          language
        }
        _count {
          fabric_groups
        }
      }
    }
    ungroupedFeatures: findManyFabricFeature(
      where: { fabricFeatureGroupId: { equals: null } }
      orderBy: { id: asc }
    ) {
      id
      code
      photo {
        id
        src_xs
        src
      }
      fabric_feature_profiles {
        id
        name
        language
      }
      _count {
        fabric_groups
      }
    }
  }
`

export const GET_FABRIC_FEATURE_GROUP = gql`
  query GetFabricFeatureGroup($id: Int!) {
    findUniqueFabricFeatureGroup(where: { id: $id }) {
      id
      code
      fabric_feature_group_profiles {
        id
        name
        language
      }
      fabric_features {
        id
      }
    }
  }
`

export const CREATE_FABRIC_FEATURE_GROUP = gql`
  mutation CreateFabricFeatureGroup($data: CreateFabricFeatureGroupWithProfilesInput!) {
    createFabricFeatureGroup(data: $data) {
      id
    }
  }
`

export const UPDATE_FABRIC_FEATURE_GROUP = gql`
  mutation UpdateFabricFeatureGroup($where: WhereUniqueInput!, $data: UpdateFabricFeatureGroupWithProfilesInput!) {
    updateFabricFeatureGroup(where: $where, data: $data) {
      id
    }
  }
`

export const DELETE_FABRIC_FEATURE_GROUP = gql`
  mutation DeleteFabricFeatureGroup($where: FabricFeatureGroupWhereUniqueInput!) {
    deleteOneFabricFeatureGroup(where: $where) {
      id
    }
  }
`

export const GET_FEATURE_GROUPS_FOR_SELECT = gql`
  query GET_FEATURE_GROUPS_FOR_SELECT {
    findManyFabricFeatureGroup(orderBy: { id: asc }) {
      id
      code
      fabric_feature_group_profiles {
        id
        name
        language
      }
    }
  }
`
